module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGID")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before Autumn")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of Starry-Eyed Children")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intercession to Saint Brigid")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mist and Fog")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of Earth and Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Landscape for Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight Modes toward Desire")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thin Places")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ice Palaces")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YGMALION")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Memory of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soldiers")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fretwork")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Voices’ End")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embers")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Far from Home")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wise and Innocent")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Distance from Here to There")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brussels Sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crystalline")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Saints’ Day")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Souls’ Day")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons in Nostalgia")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enigmatic")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apogee")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triptych")])]), _vm._v(" "), _c('p', {
    staticClass: "back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0